if (!window.__ndCartLoaded) {
window.__ndCartLoaded = true;
/* NODE Triton — timer de reserva do carrinho (persiste na sessão, sobrevive re-render do drawer) */
class NdCartTimer extends HTMLElement {
  connectedCallback() {
    const seconds = Number(this.dataset.seconds || (Number(this.dataset.minutes || 1) * 60));
    let deadline = Number(sessionStorage.getItem('nd_cart_deadline') || 0);
    if (!deadline || deadline < Date.now()) {
      deadline = Date.now() + seconds * 1000;
      sessionStorage.setItem('nd_cart_deadline', String(deadline));
    }
    const label = this.querySelector('[data-nd-timer]');
    if (!label) return;
    const render = () => {
      const left = deadline - Date.now();
      if (left <= 0) {
        label.textContent = '0:00';
        clearInterval(this.tick);
        return;
      }
      const m = Math.floor(left / 60000);
      const s = Math.floor((left % 60000) / 1000);
      label.textContent = m + ':' + String(s).padStart(2, '0');
    };
    render();
    this.tick = setInterval(render, 1000);
  }

  disconnectedCallback() {
    clearInterval(this.tick);
  }
}
if (!customElements.get('nd-cart-timer')) customElements.define('nd-cart-timer', NdCartTimer);

/* Cupom da gaveta: aplica pelo Ajax do carrinho e re-renderiza a gaveta com o desconto visível */
class NdCartCoupon extends HTMLElement {
  static markApplied(code) {
    document.querySelectorAll('nd-cart-coupon[data-code="' + code + '"]').forEach((el) => {
      el.classList.add('is-applied');
      const b = el.querySelector('[data-nd-apply]');
      if (b) { b.disabled = true; b.textContent = 'Applied'; }
    });
  }

  connectedCallback() {
    const btn = this.querySelector('[data-nd-apply]');
    if (!btn) return;
    // ao abrir/re-renderizar: se o código já está no carrinho, mostra como aplicado
    fetch(window.Shopify.routes.root + 'cart.js').then((r) => r.json()).then((c) => {
      if ((c.discount_codes || []).some((d) => d.code === this.dataset.code && d.applicable)) NdCartCoupon.markApplied(this.dataset.code);
    }).catch(() => {});
    btn.addEventListener('click', async () => {
      btn.disabled = true;
      btn.textContent = 'Applying…';
      try {
        const res = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: this.dataset.code, sections: 'cart-drawer,cart-icon-bubble' }),
        });
        const state = await res.json();
        const ok = (state.discount_codes || []).some((d) => d.code === this.dataset.code && d.applicable);
        const drawer = document.querySelector('cart-drawer');
        if (ok && drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
          NdCartCoupon.markApplied(this.dataset.code);
        } else {
          btn.disabled = false;
          btn.textContent = ok ? 'Applied' : 'Not valid';
        }
      } catch (err) {
        console.error('[nd-cart-coupon]', err);
        btn.disabled = false;
        btn.textContent = 'Apply';
      }
    });
  }
}
if (!customElements.get('nd-cart-coupon')) customElements.define('nd-cart-coupon', NdCartCoupon);

/* Barra de progresso da promoção: anima do valor anterior até o atual e pulsa a etapa recém-conquistada */
class NdCartProgress extends HTMLElement {
  connectedCallback() {
    const fill = this.querySelector('.nd-gami__fill');
    if (!fill) return;
    const p = Number(this.dataset.p || 0);
    const n = Number(this.dataset.count || 0);
    let prev = { p: 0, n: 0 };
    try { prev = JSON.parse(sessionStorage.getItem('nd_gami_prev')) || prev; } catch (e) {}
    try { sessionStorage.setItem('nd_gami_prev', JSON.stringify({ p, n })); } catch (e) {}
    if (prev.p === p || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    fill.style.transition = 'none';
    fill.style.setProperty('--nd-gami-p', prev.p);
    requestAnimationFrame(() => requestAnimationFrame(() => {
      fill.style.transition = '';
      fill.style.setProperty('--nd-gami-p', p);
    }));
    if (n > prev.n) {
      this.querySelectorAll('.nd-gami__step.is-hit').forEach((s) => {
        if (Number(s.dataset.take) > prev.n) s.classList.add('is-pop');
      });
    }
  }
}
if (!customElements.get('nd-cart-progress')) customElements.define('nd-cart-progress', NdCartProgress);

/* "Add to your order": o "+ Add" põe a peça direto no carrinho, sem personalização, no mesmo tamanho da camisa que já
   está lá (variante vem pronta em data-nd-recs-direct); sem esse tamanho, abre os tamanhos no card. Sem sair da gaveta. */
const ndRecsFechar = () => {
  document.querySelectorAll('.nd-recs__sizes').forEach((el) => { el.hidden = true; });
  document.querySelectorAll('[data-nd-recs-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
};

const ndRecsAdicionar = async (card, variantId, aoFalhar) => {
  if (card.classList.contains('is-loading')) return;
  card.classList.add('is-loading');
  const err = card.querySelector('.nd-recs__err');
  if (err) err.hidden = true;
  try {
    const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    });
    const state = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(state.description || state.message || 'Could not add this item. Please try again.');
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(state);
  } catch (ex) {
    console.error('[nd-cart-recs]', ex);
    card.classList.remove('is-loading');
    if (aoFalhar) aoFalhar();
    if (err) {
      err.textContent = ex.message;
      err.hidden = false;
    }
  }
};

document.addEventListener('click', (e) => {
  const opener = e.target.closest('[data-nd-recs-open]');
  const closer = e.target.closest('[data-nd-recs-close]');
  const chip = e.target.closest('[data-nd-recs-variant]');
  if (!opener && !closer && !chip) return;
  const card = e.target.closest('[data-nd-recs-card]');
  if (!card) return;
  const panel = card.querySelector('.nd-recs__sizes');
  const abrirPainel = () => {
    ndRecsFechar();
    panel.hidden = false;
    card.querySelector('[data-nd-recs-open]').setAttribute('aria-expanded', 'true');
  };
  if (chip) {
    ndRecsAdicionar(card, chip.dataset.ndRecsVariant);
    return;
  }
  if (opener && opener.dataset.ndRecsDirect) {
    ndRecsAdicionar(card, opener.dataset.ndRecsDirect, abrirPainel);
    return;
  }
  const abrir = Boolean(opener) && panel.hidden;
  ndRecsFechar();
  if (abrir) abrirPainel();
});

}
